import { Controller } from 'stimulus'
import Sortable from 'sortablejs'
import { showToast } from '../../admin/toast'

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: '.sortable-handle',
      draggable: 'tr',
      animation: 150,
      onEnd: this.onEnd.bind(this),
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  onEnd(evt) {
    if (evt.oldIndex === evt.newIndex) return

    const name = evt.item.dataset.name || 'Баннер'
    const from = evt.oldIndex + 1
    const to = evt.newIndex + 1
    const message = `«${name}» перемещён с позиции ${from} на позицию ${to}`

    this.save(message)
  }

  save(message) {
    const bannerIds = [...this.element.querySelectorAll('tr[data-id]')].map(
      (row) => row.dataset.id
    )

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRF-Token': this.csrfToken,
      },
      body: JSON.stringify({ banner_ids: bannerIds }),
    }).then((response) => {
      if (response.ok) {
        showToast(message)
      } else {
        showToast('Не удалось сохранить порядок', 'danger')
        window.location.reload()
      }
    })
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content
  }
}
